module.exports = __webpack_public_path__ + "img/keyboard-arrow-top-left.fb08bc1b.svg";